import * as React from "react";
import {useCallback, useState} from "react";
import {
    BoxAccess,
    classNames,
    CloseButton,
    layout,
    PushButton,
    theme,
    usePlatform, useStorageItemValue,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";
import {useLocalization} from "../../i18n";
import {stylesheet} from "typestyle";
import {Tenant} from "../types";
import {Box} from "@variocube/app-api";

export interface RentalViewProps {
    onClose: () => void;
}

export function UserView({onClose}: RentalViewProps) {
    const platform = usePlatform();
    const {t} = useLocalization();

    const tenant = useStorageItemValue<Tenant>("tenant");
    const plasticBagBoxes = useStorageItemValue<string[]>("plasticBagBoxes");
    const plasticBagBoxes2Rolls = useStorageItemValue<string[]>("plasticBagBoxes2Rolls");
    const bigBagBoxes = useStorageItemValue<string[]>("bigBagBoxes");
    const wasteBoxes = useStorageItemValue<string[]>("wasteBoxes");
    const [textPrefix, setTextPrefix] = useState<string>("Waste");

    const [box, setBox] = useState<Box | undefined>();

    const handleChoseRandom = useCallback( (boxes: string[]) => {
        const randomBoxNumber = boxes[Math.floor(Math.random() * boxes.length)];
        const box = platform.boxes.filter((b => b.number == randomBoxNumber)).pop();
        if(box) {
            setBox(box);
        }
    }, []);

    const handlePlasticBags = useCallback(() => {
        if(plasticBagBoxes) {
            setTextPrefix("PlasticBags");
            handleChoseRandom(plasticBagBoxes);
        }
    }, [plasticBagBoxes]);
    const handlePlasticBags2Rolls = useCallback(() => {
        if(plasticBagBoxes2Rolls) {
            setTextPrefix("PlasticBags");
            handleChoseRandom(plasticBagBoxes2Rolls);
        }
    }, [plasticBagBoxes2Rolls]);
    const handleBigBags = useCallback(() => {
        if(bigBagBoxes) {
            setTextPrefix("BigBags");
            handleChoseRandom(bigBagBoxes);
        }
    }, [bigBagBoxes]);
    const handleWaste = useCallback(() => {
        if(wasteBoxes) {
            setTextPrefix("Waste");
            handleChoseRandom(wasteBoxes);
        }
    }, [wasteBoxes]);

    const handleConfirm = useCallback(() => {
        setBox(undefined);
        onClose();
    }, [onClose]);

    if(box) {
        return (<BoxAccess boxes={[box]} platform={platform}
                           onConfirm={handleConfirm}
                           onCancel={() => setBox(undefined)}
                           boxOpenTitle={t(textPrefix + "OpenTitle" as any)}
                           boxOpenMessage={t(textPrefix + "OpenMessage" as any)}
                           confirmTitle={t(textPrefix + "ConfirmTitle" as any)}
                           confirmMessage={t(textPrefix + "ConfirmMessage" as any)}
                           strings={t} />);
    }

    return (
        <View>
            <ViewHeader className={theme.lessContrast}>
                <ViewHeaderItem fill className={classNames(layout.paddingMedium, styles.branding)}>
                    {t("Welcome")}: {tenant ? tenant.user : "..."}
                </ViewHeaderItem>
                <CloseButton label={t("Close")} onClick={onClose}/>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.paddingMedium, layout.alignCenter, layout.spaceEvenly)}>
                <div className={(classNames(layout.horizontal))}>
                    <div className={classNames(theme.moreContrast, layout.vertical, layout.spaceBetween, styles.boxSizeLeft)}>
                        <div className={classNames(styles.boxTitle)}>
                            <div>{t("Bags")}</div>
                        </div>
                        <div className={classNames(styles.boxInfo)}>{t("BagsInfo")}</div>
                        <div className={classNames(layout.horizontal, layout.spaceEvenly)}>
                            <PushButton onClick={handlePlasticBags}>{t("PlasticBags1RollButton")}</PushButton>
                            <PushButton onClick={handlePlasticBags2Rolls}>{t("PlasticBags2RollButton")}</PushButton>
                        </div>
                        <div style={{paddingTop: "1rem"}}>
                            <PushButton className={styles.fullWidth} onClick={handleBigBags}>{t("BigBagsButton")}</PushButton>
                        </div>
                    </div>
                    <div className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxSizeRight)}>
                        <div className={classNames(styles.boxTitle)}>
                            <div>{t("Waste")}</div>
                        </div>
                        <div className={classNames(styles.boxInfo)}>
                            {t("WasteInfo")}
                        </div>
                        <div className={classNames(layout.horizontal, layout.spaceEvenly)}>
                            <PushButton onClick={handleWaste}>{t("WasteButton")}</PushButton>
                        </div>
                    </div>
                </div>
                <div className={classNames(layout.vertical)}>
                    <div>{t("Charged")}</div>
                </div>
            </ViewContent>

        </View>
    );
}

const styles = stylesheet({
    branding: {
        fontSize: "2em",
        fontWeight: 300,
        color: "var(--color-primary)"
    },
    boxSizeLeft: {
        width: "24em",
        height: "18em",
        padding: "1.5em"
    },
    boxSizeRight: {
        width: "16em",
        height: "18em",
        padding: "1.5em"
    },
    boxTitle: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.25em"
    },
    boxInfo: {
        textAlign: "justify",
        height: "7em"
    },
    fullWidth: {
        width: "100%"
    }
});